export const RequestStatus = {
  Loading: 'loading',
  Success: 'success',
  Initial: 'initial',
  Error: 'error',
}

export function isLoading(request) {
  return request.status === RequestStatus.Loading
}

export function isSuccess(request) {
  return request.status === RequestStatus.Success && !request.data?.error?.code
}

export function isError(request) {
  return request.status === RequestStatus.Error
}

export function isInitial(request) {
  return request.status === RequestStatus.Initial
}

export function initial() {
  return {
    status: RequestStatus.Initial,
  }
}

export function loading() {
  return {
    status: RequestStatus.Loading,
  }
}

export function success(data) {
  return {
    status: RequestStatus.Success,
    data,
  }
}

export function error(error) {
  return {
    status: RequestStatus.Error,
    error,
  }
}
